var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.5,90.7c-2.8-35.6-32.6-63.8-68.9-63.8H69.1C31,26.9,0,57.9,0,96V416c0,38.1,31,69.1,69.1,69.1h373.7 c38.1,0,69.1-31,69.1-69.1V157.2C512,125.6,490.6,98.8,461.5,90.7L461.5,90.7z M69.1,59.2h323.5c17.6,0,32.3,12.4,36,28.9H69.1 C55.6,88.1,43,92,32.3,98.8V96C32.3,75.7,48.8,59.2,69.1,59.2z M442.9,452.8H69.1c-20.3,0-36.8-16.5-36.8-36.8V157.2 c0-20.3,16.5-36.8,36.8-36.8h373.7c20.3,0,36.8,16.5,36.8,36.8v56.4h-103c-40.8,0-74,33.2-74,74c0,40.8,33.2,74,74,74h103V416 C479.7,436.3,463.2,452.8,442.9,452.8L442.9,452.8z M479.7,329.3h-103c-23,0-41.7-18.7-41.7-41.7c0-23,18.7-41.7,41.7-41.7h103 V329.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 382.7,
    cy: 288.8,
    r: 16.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3a6adf37ae4efb4d2ed5e87bdb737d9a.svg";
export { ForwardRef as ReactComponent };